import { useEffect } from "react";
import { notifyParentCustomerUrl } from "./customerDeepLink";

const useCustomerParentUrlSync = (search) => {
  useEffect(() => {
    notifyParentCustomerUrl(search);
  }, [search]);
};

export default useCustomerParentUrlSync;
